export const getConstructorInfo = (state) => state.requestConstructor.data
export const getWorkflowId = (state) => getConstructorInfo(state).id
